<template>
  <utd-toast ref="toastRef"
             position="top-right"
             :title="successMessage().heading"
             :message="successMessage().message"
             @closed="handleClosed" />
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import PubSub from '_acaSrc/utility/PubSub';
import useRegistrationForm from '_acaSrc/composables/registrationForm.composable';
import useRegisterMergeStatus from '_acaSrc/composables/registerMergeStatus.composable';
import { setQueryParamValueNoReload } from '_acaSrc/utility/Browsers';
import { C_REG_MERGE } from '_acaSrc/utility/constants';
import UtdToast from '_acaSrc/components/shared/stdlib/UtdToast.vue';

const { successMessage, clearSuccessMessage } = useRegistrationForm();
const { mergeType, resetMergeStatus } = useRegisterMergeStatus();

const pubsub = new PubSub();
const toastRef = ref(null);

const showToast = () => {
    if (mergeType.value !== C_REG_MERGE.MESSAGES.REG.name) {
        return;
    }
    toastRef.value?.show();
};

const handleClosed = () => {
    setQueryParamValueNoReload(C_REG_MERGE.REG_MERGE_SUCCESS_PARAM);
    clearSuccessMessage();
    resetMergeStatus();
};

onMounted(() => {
    pubsub.subscribe('showSuccessNotification', showToast);
});

onUnmounted(() => {
    pubsub.unsubscribe('showSuccessNotification');
});
</script>
